module.exports = __webpack_public_path__ + "media/images/lps-graph-23839220.png";